export const environment = {
  production: true,

  apiUrl: 'https://esrnm-api-test.jahezteam.com/api/Web/',
  apiUrl2: 'https://esrnm-api-test.jahezteam.com/api/',

  imageUrl: 'https://esrnm-api-test.jahezteam.com/',
  DashboardLink: 'https://esrnm-admin-test.jahezteam.com',
  returnedUrl: 'https://esrnm-web-test.jahezteam.com/'
  // returnedUrl: 'http://localhost:4200/'

}